import styled from 'styled-components'

const DashboardContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 1rem 0;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
`

const Title = styled.h1`
  color: #333;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
`

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
  }
`

const Button = styled.button<{ $variant?: 'primary' | 'danger' }>`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;

  @media (max-width: 480px) {
    padding: 0.6rem 0.8rem;
    font-size: 0.85rem;
  }

  ${props =>
    props.$variant === 'primary'
      ? `
    background: #007bff;
    color: white;
    
    &:hover {
      background: #0056b3;
    }
  `
      : props.$variant === 'danger'
      ? `
    background: #dc3545;
    color: white;
    
    &:hover {
      background: #c82333;
    }
  `
      : `
    background: #6c757d;
    color: white;
    
    &:hover {
      background: #545b62;
    }
  `}
`

const ContentSection = styled.section`
  margin-bottom: 2rem;
`

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

const SectionTitle = styled.h2`
  color: #333;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`

const MapsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
  }
`

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #666;
`

const EmptyStateTitle = styled.h3`
  margin-bottom: 1rem;
  color: #333;
`

const LoadingContainer = styled.div`
  text-align: center;
  padding: 3rem;
  color: #666;
`

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    gap: 1rem;
    width: 100%;
  }
`

const NavLink = styled.a<{ onClick?: () => void }>`
  color: #666;
  text-decoration: none;
  font-size: 0.9rem;
  padding: 0.5rem 0;
  transition: color 0.2s ease;
  cursor: pointer;

  &:hover {
    color: #007bff;
    text-decoration: underline;
  }

  &[target='_blank'] {
    color: #007bff;
  }
`

export {
  DashboardContainer,
  Header,
  Title,
  UserInfo,
  Button,
  ContentSection,
  SectionHeader,
  SectionTitle,
  MapsGrid,
  EmptyState,
  EmptyStateTitle,
  LoadingContainer,
  NavLinks,
  NavLink,
}
